import { RouteType } from '@/lib/route';
import ContentManager from '@/pages/ContentManager/index';
import CategoryView from './components/CategoryView';

export enum ContentManagerTabs {
  Categories = 'categories',
}

export const ContentManagerBaseRoutes: RouteType = {
  path: '/content-manager/:tabSelected',
  component: ContentManager,
};

export const ContentManagerCategoryRoutes: RouteType = {
  path: `/content-manager/${ContentManagerTabs.Categories}/:categoryId`,
  component: CategoryView,
};

export interface ContentManagerParamTypes {
  tabSelected: string;
  categoryId: string;
}

export default ContentManagerBaseRoutes;
